(function () {
  const mountPurchaseRow = (infoContainer) => {
    if (!infoContainer) return;

    const variantBlock = infoContainer.querySelector('.pdp-block--variant_picker');
    const volumeDiscountBlock = infoContainer.querySelector('.pdp-block--volume_discount');
    const quantityBlock = infoContainer.querySelector('.pdp-block--quantity_selector');
    const buyButtonsBlock = infoContainer.querySelector('.pdp-block--buy_buttons');
    const shippingBanner = infoContainer.querySelector('.pdp-shipping-banner');

    if (!quantityBlock || !buyButtonsBlock) return;

    let purchaseRow = infoContainer.querySelector('[data-pdp-purchase-row]');
    let shippingRow = infoContainer.querySelector('[data-pdp-shipping-row]');

    if (!purchaseRow) {
      purchaseRow = document.createElement('div');
      purchaseRow.className = 'pdp-purchase-row';
      purchaseRow.setAttribute('data-pdp-purchase-row', '');
    }

    if (shippingBanner && !shippingRow) {
      shippingRow = document.createElement('div');
      shippingRow.className = 'pdp-shipping-row';
      shippingRow.setAttribute('data-pdp-shipping-row', '');
    }

    const anchorBlock = volumeDiscountBlock || variantBlock || quantityBlock;
    if (!anchorBlock) return;

    if (purchaseRow.parentElement !== infoContainer || anchorBlock.nextElementSibling !== purchaseRow) {
      anchorBlock.insertAdjacentElement('afterend', purchaseRow);
    }

    if (quantityBlock.parentElement !== purchaseRow) {
      purchaseRow.appendChild(quantityBlock);
    }

    if (buyButtonsBlock.parentElement !== purchaseRow) {
      purchaseRow.appendChild(buyButtonsBlock);
    }

    if (shippingBanner && shippingRow) {
      if (shippingBanner.parentElement !== shippingRow) {
        shippingRow.appendChild(shippingBanner);
      }

      if (shippingRow.parentElement !== infoContainer || purchaseRow.nextElementSibling !== shippingRow) {
        purchaseRow.insertAdjacentElement('afterend', shippingRow);
      }
    }

    infoContainer.setAttribute('data-purchase-row-ready', 'true');
  };

  const mountAllPurchaseRows = () => {
    document.querySelectorAll('[id^="ProductInfo-"]').forEach((infoContainer) => {
      mountPurchaseRow(infoContainer);
    });
  };

  const scheduleMount = () => window.requestAnimationFrame(mountAllPurchaseRows);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount, { once: true });
  } else {
    scheduleMount();
  }

  document.addEventListener('shopify:section:load', scheduleMount);
})();
